<template>
        <Success v-show="isSuccess" :success_msg="operation_info" @close="isSuccess = false"/>
        <Error v-show="isError" :error_msg="error_text" @close="isError = false" />
    <div v-show="is_window_show" class="win_bg"></div>
    <div v-show="is_window_show" class="win">
        <div class="btn_win_close" @click="is_window_show = false">[X]</div>
        <div class="win-header">Добавить аспект</div>
        <br><br>
        <div class="header-for-input">Тип аспекта</div>
        <select class="content-input" v-model="kcop_criteria.aspect_type">
            <option value="1">Дискретный</option>
            <option value="2">Бинарный</option>
        </select>
        <div class="header-for-input">Наименование аспекта</div>
        <input type="text" class="content-input" v-model="kcop_criteria.name" />
        <div class="header-for-input">Аббревиатура аспекта</div>
        <input type="text" class="content-input" v-model="kcop_criteria.abbreviation" />
        <div class="header-for-input">Значение аспекта</div>
        <input type="text" class="content-input" v-model="kcop_criteria.value" />
        <br><br>
        <button  class="aspect_btn"  @click="is_window_show = false" >Отмена</button>
        <button  class="aspect_btn" @click="create_criteria" >Добавить</button>
    </div>
</template>

<script>

import Success from '@/components/elements/success.vue'
import Error from '@/components/elements/error.vue'

export default {
    name: 'Createkcopcriteria',
    emits: ['update_criteria'],
    components: {Success, Error},
    props: {
        kcop_criteria_id: String
    },
    data() {
        return {
            /* common vars */
            isSuccess: false,
            operation_info: '',
            error_text: '',
            isError: '',
            /* common vars */
            is_window_show: false,
            kcop_criteria: {
                kcop_criteria_id: 0,
                aspect_type: 0,
                name: '',
                abbreviation: '',
                value: ''
            }
        }
    },
    methods: {
        create_criteria() {
            //console.log(this.kcop_id)
            this.kcop_criteria.kcop_criteria_id = this.kcop_criteria_id
            let loader = this.$loading.show()
            this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
            this.axios.post(process.env.VUE_APP_API_URL + '/api/kcop_criteria_aspects', this.kcop_criteria)
                .then(response => { 
                    loader.hide();
                    console.log(response.data.data)
                    this.is_window_show = false
                    this.$emit('update_criteria')
                })
                .catch(error => {
                    //let loader = this.$loading
                    loader.hide();
                    this.error_text = error.response.status + ' ' + error.response.data.data;
                    this.isError = true;
            });
        }
    },
}

</script>


<style scoped>
    .win_bg {
        display: block;
        position: fixed;
        width: 100% !important;
        height: 100% !important;
        background: #000000;
        opacity: 0.6;
        z-index: 999;
        left: 0px;
        top: 0px;
    }
    .win {
        display: block;
        width: 500px !important;
        height: 600px !important;
        position: absolute;
        background: #ffffff;
        left: 50%;
        margin-left: -150px;
        top: 150px;
        z-index: 1000;
        border-radius: 7px;
        box-sizing: border-box;
        padding: 15px;
        margin-bottom: 50px !important;
    }
    .win-header {
        font-size: 20px;
    }
    .btn_win_close {
        display: block;
        position: absolute;
        width: 15px;
        height: 15px;
        cursor: pointer;
        right: 15px;
    }
    .btn_win_close:hover {
        color: blue;
    }
    .aspect_btn {
        margin-left: 10px;
    }
</style>

<style scoped src="../../assets/style/main.css"></style>
<style scoped src="../../assets/style/account.css"></style>
<style scoped src="../../assets/style/buttons.css"></style>